// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import stylizr from '@aftonbladet/stylizr';

import type {
  TextBlock,
  ListBlock,
  Text,
  ListBlockTypes,
  TextBlockTypes,
} from '../../../data-sources/content-components/types.js';
import type { IStubertoArticle } from '../../../data-transformations/huberto/types.js';
import type { Story } from '../../../data-sources/frapi/data-types.js';

import { isTextBlock } from '../../../data-sources/content-components/type-guards.js';

const stylizrInstance = stylizr({
  'style:strong': (text: string) => `<strong>${text}</strong>`,
  'style:em': (text: string) => `<em>${text}</em>`,
  'style:superscript': (text: string) => `<sup>${text}</sup>`,
  'style:subscript': (text: string) => `<sub>${text}</sub>`,
});

const styliz = (text: Text): string => {
  if (text.markup && text.markup.length === 0) {
    return text.value;
  }

  return [...stylizrInstance(text.value, text.markup)].join('');
};

export const convertBackgroundToMd = (
  background: TextBlock[] | ListBlock[],
): string => {
  const blockList: {
    blockType: ListBlockTypes | TextBlockTypes;
    literal: string;
  }[] = [];

  // styliz where needed and return a list of blocks
  background.forEach((block) => {
    let stylizd = '';

    if (isTextBlock(block)) {
      stylizd = styliz(block.text);
    } else if (block.items) {
      stylizd = block.items
        .map((item, index) => {
          const marker =
            block.blockType === 'list:ordered' ? `${index + 1}.` : '-';

          return `${marker} ${styliz(item)}`;
        })
        .join('\n');
    }

    blockList.push({ blockType: block.blockType, literal: stylizd });
  });

  // map each block to md
  return blockList
    .map((block) => {
      switch (block.blockType) {
        case 'heading':
          return `# ${block.literal}`;
        case 'quote':
          return `> ${block.literal}`;
        default:
          return block.literal;
      }
    })
    .join('\n\n');
};

const bundleSubpageUrlOverrides: { [id: string]: string } = {
  '3828cec5-37ed-49e6-84d8-acb0f62712ed':
    'https://www.aftenposten.no/implantert',
};

export class BundleInfo {
  title: string;
  description: string;
  url: string;
  bundleId: string;
  id: string;

  constructor(bundle: Story, bundleArticles: IStubertoArticle[]) {
    this.title = bundle?.title;
    this.id = bundle?.id;
    // use background if present and fallback to description
    this.description = bundle?.background
      ? convertBackgroundToMd(bundle.background)
      : bundle?.description || '';

    const str = bundle?.slug || this.title?.replace(/ /gi, '_');

    this.url =
      bundleSubpageUrlOverrides[bundle?.id] ||
      'https://www.aftenposten.no/emne/' + str;
    this.bundleId = `${str || 'unknown'}_${bundleArticles
      .map((t) => t.id)
      .join('-')}`;
  }
}
